import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { installGoogleTagManager } from "./utils/googleTagManager";

// Hard redirect for the domain root and any mistyped address (e.g. /bay-error, /area).
// Runs before the app renders so visitors are always sent to a real page.
const knownPaths = ["/bay-area", "/northern-california", "/out-of-state", "/book-tour", "/thank-you"];

// If the thank-you page loads inside the booking calendar (Acuity's post-booking
// redirect), break out so it opens as the full page instead of inside the frame.
if (window.self !== window.top && window.location.pathname.replace(/\/+$/, "") === "/thank-you") {
  try {
    // Only break out when the outer page is our own site (reading origin throws if it isn't),
    // so previews inside other tools are never navigated away.
    if (window.top && window.top.location.origin === window.location.origin) {
      window.top.location.href = window.location.href;
    }
  } catch {
    // Outer page is a different site — leave as is.
  }
}
const currentPath = window.location.pathname.replace(/\/+$/, "").toLowerCase() || "/";
if (!knownPaths.includes(currentPath)) {
  window.location.replace(`/bay-area${window.location.search}${window.location.hash}`);
} else {
  installGoogleTagManager();
  const rootEl = document.getElementById("root");
  if (rootEl) {
    ReactDOM.createRoot(rootEl).render(<App data-id="element-96" data-mp="1tbeoez1pn7ky" />);
  }
}